<template>
    <div id="verified">
        
        <div class="card-other">
            <h4>尊敬的用户,为了贯彻工信部《电话用户真实身份信息登记规定》,请对您购买的流量卡进行实名认证。</h4>
            <div class="main">
                
                <van-cell-group>
                    <van-field 
                        v-model="verifiedInfo.iccid"
                        clearable
                        left-icon="info-o"
                        placeholder="请输入iccid" 
                        :disabled='isFirst == 2'
                    />

                    <van-field 
                        v-model="verifiedInfo.name"
                        clearable
                        left-icon="user-o"
                        placeholder="请输入真实姓名" 
                        :disabled='isFirst == 2'
                    />

                    <van-field 
                        v-model="verifiedInfo.idcard"
                        clearable
                        maxlength="18"
                        left-icon="idcard"
                        placeholder="请输入身份证号" 
                        :disabled='isFirst == 2'
                    />

                    <van-field 
                        v-model="verifiedInfo.userPhone"
                        maxlength="11"
                        clearable
                        left-icon="phone-o"
                        placeholder="请输入11位手机号码" 
                        :disabled='isFirst == 2'
                    />
                </van-cell-group>
                <div class="btnOuter">
                    <mt-button class="tag-read" type="primary" size="large" @click.prevent="sureVerifiedHandler"   data-clipboard-action="copy"
                    :data-clipboard-text="verifiedInfo.iccid"   v-if="isFirst == 0">点击复制卡号，去完成实名</mt-button>
                    <mt-button type="primary" size="large" @click.prevent="payRealName" v-if="isFirst == 2">支付实名费用</mt-button>
                </div>        
                <!-- <p style="color:red;padding-top:20px;">真实姓名、身份证号、手机号三者请务必与您的真实信息保持一致！</p> -->
                <div style="color:red;padding-top:20px;line-height: 24px;">
                    <p>温馨提示：</p>
                    <p>1、请确保您的实名手机号，姓名，身份证信息三者保持一致，否则将无法通过验证！</P>
                    <p>2、用户第一次申请验证，无需支付费用，第二次开始每次认证需支付0.5元信息认证费。请确保填写信息正确，以免产生额外费用，谢谢！</P>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Clipboard from 'clipboard';
import {wxRequest, verified} from '@/api/user'
import { Dialog, Toast } from 'vant';
export default {
    data(){
        return {
            verifiedInfo: {
                iccid: localStorage.getItem('iccid'),
                name: '',
                userPhone: '',
                idcard: ''
            },
            disabledFlag: false,
            isFirst: 0
        }
    },
    methods: {
        getVerifiedInfoHandler(){            
            var data = {
                iccid: localStorage.getItem('iccid')
            }
            wxRequest('bindPhone/phone/info/iccid', data, 'post').then(res => {
                if(res.data.code == 200 && res.data.data){
                    for(var key in this.verifiedInfo){
                        this.verifiedInfo[key] = res.data.data[key];
                    }
                }
            })
        },
        sureVerifiedHandler(){
        var clipboard = new Clipboard('.tag-read')
        clipboard.on('success', e => {
                  console.log('复制成功')
                  clipboard.destroy()// 释放内存
             })
            wxRequest("bindPhone/phone", this.verifiedInfo, "post").then(res => {
                if(res.data.code == 200){
                  var isothrBind=localStorage.getItem('isothrBind');
                     window.location.href='http://iotapp.iot.189.cn:9090/uapp/certifhtml/certif_entry.html?userCode=r/s9Tc00hjiKcR13MIjZHg==&passWord=9u8VuY1xbez6r6k/BBnLlw==&tmstemp=1581922935504';
                }else if(res.data.code == 777){
                    Dialog.alert({message: res.data.message,}).then(() => {//跳转到支付实名费用
                        this.isFirst = 2;
                        this.userPhone = '';
                        this.idcard = '';
                        this.name = '';
                    });
                }else {
                    this.$messagebox.alert(res.data.message);
                }
            })
        },
        //支付实名
        payRealName(){
            let fd = new FormData();
            fd.append("iccid", this.verifiedInfo.iccid);
            let _this = this;
            wxRequest('order/bind/phone', fd, 'post').then(res => {
                let param = res.data.data.param;        
                WeixinJSBridge.invoke(
                    'getBrandWCPayRequest', param,
                    function(res){
                        if(res.err_msg == "get_brand_wcpay_request:ok" ){
                            window.location.href = 'http://wechat.liuliangka.co/#/user/loginBInd'
                        } 
                    }
                );
            })
        }
    },
    created(){
       this.getVerifiedInfoHandler();
       
    },

    mounted(){
        this.verifiedInfo.iccid = this.$route.query.iccid?this.$route.query.iccid:localStorage.getItem('iccid');
        wxRequest("bindPhone/state", {iccid: this.verifiedInfo.iccid}, "post").then(res => {
            if(res.data.code == 200){
                let result = res.data.data;
                if(result.bindState == 2){
                    this.isFirst = result.isFirst;
                }else {
                    this.disabledFlag = true;
                }
            }else{
                Dialog.alert({title: '提示', message:res.data.message});
            }
        })
        if(this.isFirst == 2){
            Dialog({ message: '尊敬的用户，您当前有未支付的实名失败订单，请你优化支付完订单信息，再重新登录实名认证。' });
        }
    }
}
</script>
<style lang="less">
#verified {
    height: 100%;
    h4 {
        color: #fff;
        font-size: 10px;
        background: #26a2ff;
        line-height: 1.5em;
        padding: 6px 3%;
    }
    .main {
        height: calc(100% - 48px);
        padding: 0 4%;
        form{
            height: 100%;
        }
        .line {
            border-bottom: 1px solid #e5e5e5;
        }
        // .many {
        //     display: flex;
        //     justify-content: space-between;
        //     label {
        //         display: block;
        //         line-height: 36px;
        //     }
        //     .uploadOuter {
        //         position: relative;
        //         display: flex;
        //         justify-content: center;
        //         align-items: center;
        //         width: 48%;
        //         height: 100px;
        //         border: 1px dashed #e5e5e5;
        //         box-sizing: border-box;
        //         input[type=file] {
        //             position: absolute;
        //             top: 0;
        //             width: 0;
        //             width: 100%;
        //             height: 100%;
        //             opacity: 0;
        //         }                
        //         img {
        //             width: 100%;
        //             height: 100%;
        //         }
        //     }
        // }
        // .title {
        //     line-height: 28px;
        //     margin-top: 10px;
        // }
        .btnOuter {
            // display: flex;
            // align-items: center;
            // height: calc(100% - 424px;)

            margin-top: 30px;
        }
    }


    .card-dianxin{
        width: 100%;
        height: 100%;
        h1{
            font-size: 14px;
            background: #fff;
            line-height: 1.5em;
            padding: 6px 3%;
        }
        .dianxin-iframe{
            width: 100%;
            height: 100%;
        }
    }

    .card-other{
        width: 100%;
        height: 100%;
    }
    input.van-field__control{
        padding-left: 5px;
        line-height: 24px;
    }
}
</style>
